
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Définition de Cash-and-Carry : Un Guide Complet pour Comprendre le Concept",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez la définition cash-and-carry et comprenez son rôle crucial dans le monde des affaires et du commerce. Transparent et efficace, le cash-and-carry est essentiel.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition de Cash-and-Carry : Un Guide Complet pour Comprendre le Concept",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez la définition cash-and-carry et comprenez son rôle crucial dans le monde des affaires et du commerce. Transparent et efficace, le cash-and-carry est essentiel.",
        },
      ],
    };
  },
};
